<style src="./QuoteConfigurations.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="quote-configurations right-panel-box" v-click-outside="closePanel">
    <div class="option-container">
      <span class="title">Limpar busca</span>
      <span class="describe">
        Após efetuar a cotação de um determinado item, a barra de buscas deverá ser limpada assim como a listagem dos items.
      </span>
      <div class="command">
        <button-toggle v-model="form.cleanSearchAfterQuote" />
      </div>
    </div>

    <div class="option-container">
      <span class="title">Ir para o próximo item</span>
      <span class="describe">
        Após efetuar a cotação de um determinado item o sistema passa para o próximo de forma automática.
      </span>

      <div class="command">
        <button-toggle v-model="form.jumpToNextItemWhenQuote" />
      </div>
    </div>

    <div class="option-container">
      <span class="title">Exibir apenas com estoque</span>
      <span class="describe">
        Filtra o resultado da busca para que seja exibido apenas itens que tenham estoque maior que zero.
      </span>

      <div class="command">
        <button-toggle v-model="form.filterOnlyWithStock" />
      </div>
    </div>

    <div class="option-container">
      <span class="title">Ordem de exibição</span>
      <span class="describe">
        Defina a prioridade para ordenar a exibição dos itens na busca
      </span>

      <div class="command">
        <dropdown
          label="Ordem de prioridade"
          placeholder="Escolha..."
          v-model="sortOrder"
          class="col-12"
          :list-data="listType"/>
      </div>
    </div>
  </section>
</template>

<script>
import { Textbox, ButtonToggle, Dropdown } from '@/components/primitives'
import { IconCheck, IconClose, IconEmpty } from '@/components/primitives/icons'

export default {
  name: 'QuoteConfigurations',
  components: {
    Textbox,
    IconCheck,
    IconClose,
    IconEmpty,
    ButtonToggle,
    Dropdown
  },
  data () {
    return {
      messages: [],
      form: {
        cleanSearchAfterQuote: null,
        jumpToNextItemWhenQuote: null,
        filterOnlyWithStock: null,
        sortOrder: null
      },
      sortOrder: null,
      listType: [
        { text: 'Ult. Compra > Qt. > Custo', value: '{ "isPreferred": -1, "lastBuyingDate": -1, "stockQuantity": -1, "cost": -1 }' },
        { text: 'Qt. > Ult. Compra > Custo', value: '{ "isPreferred": -1, "stockQuantity": -1, "lastBuyingDate": -1, "cost": -1 }' },
        { text: 'Custo > Ult. Compra > Qt.', value: '{ "isPreferred": -1, "cost": -1, "lastBuyingDate": -1, "stockQuantity": -1 }' }
      ]
    }
  },
  watch: {
    form: {
      handler (pValue) {
        this.$store.commit('ItemAssociation/CHANGE_CONFIGURATION', pValue)
      },
      deep: true
    },
    sortOrder (pValue) {
      this.form.sortOrder = pValue.value
    }
  },
  mounted () {
    const stateConfig = this.$store.getters['ItemAssociation/GET_ALL_CONFIG']
    const configDetials = Object.assign({}, this.form, stateConfig)
    this.form = configDetials
  },
  methods: {
    closePanel () {
      this.$emit('cancel')
    },
    cancel (e) {
      e.stopPropagation()
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/right-panel/quote-configurations/QuoteConfigurations.vue